import React, { FC } from "react";
import NcImage from "shared/NcImage/NcImage";
//import PostCardMeta from "components/PostCardMeta/PostCardMeta";
import { PostDataType } from "data/types";
import { Link } from "react-router-dom";
import CategoryBadgeList from "components/CategoryBadgeList/CategoryBadgeList";
import PostTypeFeaturedIcon from "components/PostTypeFeaturedIcon/PostTypeFeaturedIcon";
//import Badge from "./Badge";
import CommunityBadge from "components_custom/CommunityBadge/CommunityBadge";
import PostCardMetaV2 from "./PostCardMetaV2";
import PostCardMeta from "./PostCardMeta";
import ProductBadge from "components_custom/ProductBadge/ProductBadge";
import GuestAvatar from "assets/images/guest.png";

export interface Card3Props {
  className?: string;
  post: PostDataType;
}



const CardBasic: FC<any> = ({ className = "h-full", post, idx }) => {
  
	const { 
		type, 
		title, 
		contents,
		product_title,
		user_profileUrl,
		user_displayName,
		galleryImgs,
		createdAt
	} = post;

	const formatKoreanDate = (dateString: string) => {
		const date = new Date(dateString);
		
		const year = date.getFullYear();
		const month = ('0' + (date.getMonth() + 1)).slice(-2);
		const day = ('0' + date.getDate()).slice(-2);
		
		let hours = date.getHours();
		const minutes = ('0' + date.getMinutes()).slice(-2);
		const seconds = ('0' + date.getSeconds()).slice(-2);
	
		const period = hours >= 12 ? '오후' : '오전';
		hours = hours % 12 || 12; // 0 => 12
	
		const formattedDate = `${year}-${month}-${day}`;
		const formattedTime = `${period} ${hours}:${minutes}:${seconds}`;
	
		return {
			date: formattedDate,
			time: formattedTime,
			year: year,
			month: month,
			day: day,
		};
	};

	function removeImgTags(htmlString: string) {
		// <img> 태그를 제거하는 정규 표현식
		const imgRegex = /<img\s+[^>]*>/gi;
	
		// 정규 표현식을 사용하여 <img> 태그를 빈 문자열로 대체
		return htmlString.replace(imgRegex, '');
	}

	const profileUrl = (user_profileUrl === null)
		? `${process.env.REACT_APP_SERVER_FILE}/avatar/guest.png`
		: `${process.env.REACT_APP_SERVER_FILE}/avatar/${user_profileUrl}`; 
	const coverUrl = (galleryImgs.length === 0)? null : `${process.env.REACT_APP_SERVER_FILE}/community/${galleryImgs[0].split("_")[0]}/${galleryImgs[0]}`
	//const coverUrl = (product_cover === null)? null : `${process.env.REACT_APP_SERVER_FILE}/${product_cover}`; 
	const _contents = removeImgTags(contents)	
	const _createdAt = formatKoreanDate(createdAt);
	
  return (
	<>
		<div
			className={`nc-Card3 relative flex flex-col-reverse sm:flex-row sm:items-center rounded-[40px] group ${className}`}
		>
			<div className="flex flex-col flex-grow">
				<div className="mb-[30px]">
					<div
						className={`nc-CategoryBadgeList flex items-center flex-wrap space-x-2`}
						data-nc-id="CategoryBadgeList"
					>
						<PostCardMeta
							meta={{
								date: _createdAt.date,
								author: {
									href: "/home",
									avatar: profileUrl,
									displayName: user_displayName,
								},
							}}
						/>
						<CommunityBadge
							type={type}
						/>
					</div>
					
					<div>
						<h2
							className={`nc-card-title block font-semibold text-neutral-900 dark:text-neutral-100 text-xl mt-3`}
						>
							<Link 
								to={`/community/${post._id}`}
								className="line-clamp-1 text-[0.95rem]" 
								style={{fontWeight: "600", color:"#282f33"}}
							>
								{title}
							</Link>
						</h2>
						<div className="block mt-2 bg-white">
							<div className="overflow-hidden">
								<Link
									to={`/community/${post._id}`}
									className="line-clamp-6"
								>
									<div
										className="text-[0.85rem] leading-tight" 
										style={{fontWeight: "500", color:"#586066"}}
										dangerouslySetInnerHTML={{ __html: _contents }}
									/>
								</Link>
							</div>
						</div>
					</div>

					
					{coverUrl === null
						?
							""
						:
							<Link
								to={`/community/${post._id}`}
							>
								<img
									src={coverUrl}
									className={"mt-5 object-cover w-full rounded-2xl overflow-hidden will-change-transform h-[564px]"}
								/>				
							</Link>
						}	
					
					
				</div>
			</div>
		</div>
	</>
  );
};

export default CardBasic;
